import { getDocuments } from '3-foundation/Documents/repository';
import { mapBasePageProperties } from './basePagePropertiesMapper';
import logger from '3-foundation/Logging/logger';
import { getSiteTagsFromCDA } from '3-foundation/Site/connector';

export const mapDocumentCatalogPageProperties = async (
	properties: Umbraco.BasePage & {
		dateFilterLabel?: string;
		subjectTagsFilterLabel?: string;
		statusTagsFilterLabel?: string;
		typeTagsFilterLabel?: string;
	},
	pageId: string,
	siteId: string,
	locale: string,
): Promise<Content.DocumentCatalogPageProperties> => {
	try {
		const { documents, facets, totalDocuments } = await getDocuments({
			filters: {
				parentId: pageId,
			},
			siteId,
			locale,
		});

		const tags = await getSiteTagsFromCDA({ siteId, locale, preview: false });

		return {
			...(await mapBasePageProperties(properties, siteId, locale)),
			dateFilterLabel: properties?.dateFilterLabel || null,
			subjectTagsFilterLabel: properties?.subjectTagsFilterLabel || null,
			statusTagsFilterLabel: properties?.statusTagsFilterLabel || null,
			typeTagsFilterLabel: properties?.typeTagsFilterLabel || null,
			documents,
			facets,
			totalDocuments,
			siteTags: tags,
		};
	} catch (e) {
		logger.error(`Could not map DocumentCatalogPage Properties. \nCause: ${e.message}`, { cause: e });
		throw new Error(`Could not map DocumentCatalogPage Properties. \nCause: ${e.message}`, { cause: e });
	}
};
